import { useCallback, useEffect, useState } from "react";
import { useMemberStaleAwareData } from "../../Context/useMemberStaleAwareData";
import Icon from "../../common/Icon";
import { NotificationBannerItem } from "../NotificationBanner";
import { useNavigate } from "react-router";
import {myRenewRoute} from "../../../routes/pages/my-account/renew/route"

const useRenewSoonAlert = () => {
  const { data } = useMemberStaleAwareData();
  const [alerts, setAlerts] = useState<NotificationBannerItem[]>([]);
  const navigate = useNavigate();
  
  const calculateAlerts = useCallback((): NotificationBannerItem[] => {
    if (!data?.latestMembership?.endDate) return [];

    const endDate = new Date(data.latestMembership.endDate);
    const now = new Date();

    const msInDay = 1000 * 60 * 60 * 24;
    const daysRemaining = Math.ceil(
      (endDate.getTime() - now.getTime()) / msInDay
    );

    if (daysRemaining > 60) return [];

    if (daysRemaining >= 30) {
      return [
        {
          highlight: false,
          status: "amber",
          icon: <Icon name="information" color="#E0BC00" />,
          text: `Your account will expire in ${daysRemaining} days`,
          buttonText: "Renew",
          onButtonClick: () => navigate(myRenewRoute.path),
        },
      ];
    }

    const text = daysRemaining <= 0
      ? "Your account has expired"
      : `Your account will expire in ${daysRemaining} day${daysRemaining === 1 ? "" : "s"}`;

    return [
      {
        highlight: true,
        highlightOrder: 1,
        status: "red",
        icon: <Icon name="warning" color="red" />,
        text,
        buttonText: "Renew",
        onButtonClick: () => navigate(myRenewRoute.path),
      },
    ];
  }, [data]);

  const refresh = useCallback(() => {
    setAlerts(calculateAlerts());
  }, [calculateAlerts]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { alerts, refresh };
};

export default useRenewSoonAlert;